import React, {useEffect, useState} from 'react'
import {Row, Col, Accordion, Card} from 'react-bootstrap'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {Link, useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import Downloadicon from '../../../../media/billing/ic-download.svg'
import {useIntl} from 'react-intl'
import {
  downloadDocument,
  getAgenda,
  getMeetings,
  getMeetingSummary,
  getParticipants,
} from '../core/_requests'
import {
  getDaysDifference,
  getFileType,
  sanitizeFileName,
  shortenFilename,
  toTitleCase,
} from '../core/_util'
import Skeleton from 'react-loading-skeleton'
import AddDocumentModal from '../components/add-document-modal'
import {useAuth} from '../../auth'
import {useDateFormat} from '../../../hooks/useDateFormat'
import {useTimeZone} from '../../../hooks/useTimeZone'
import {profileData} from '../../profile/core/_requests'
import {viewableFile} from '../../../core/_util'
import ViewDocModal from '../../stakeholders/stakeholders-and-investors/components/individual/view-doc-modal'
import viewIcon from '../../../../media/stakeholders/ic-view.svg'
import deleteIcon from '../../../../media/stakeholders/ic-delete.svg'
import {DeleteFileConfirmationModal} from '../components/CancelConfimrationModal'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {toast} from 'react-toastify'
import {deleteDocument} from '../../stakeholders/stakeholders-and-investors/core/_requests'
export const AfterMeeting = () => {
  const {formatMessage} = useIntl()
  const navigate = useNavigate() // Get the navigate function
  const [tab, setTab] = useState(1)
  const options = [
    {
      id: 1,
      title: formatMessage({id: 'Meeting Details'}),
      subTitle: formatMessage({id: 'Add details of the meeting to keep everyone on track'}),
      slug: 'meeting-details',
    },
    {
      id: 2,
      title: formatMessage({id: 'Documents'}),
      subTitle: formatMessage({id: 'Add documents for easy accessibility'}),
      slug: 'meeting-documents',
    },
  ]
  const location = useLocation()
  const handleTabChange = (index: number) => {
    setTab(index + 1)
    navigate(
      `${location.pathname}?tab=${options[index].slug.toLowerCase()}${
        meetingId ? `&meetingId=${meetingId}` : ''
      }`
    )
  }
  const timeZone = localStorage.getItem('timeZone')
  const {getDateValue} = useDateFormat()
  const {getTimeZoneValue} = useTimeZone()
  const [collapseAcc, setCollapseAcc] = useState(true)
  const [activeModal, setActiveModal] = useState<'none' | 'AddDocumentModal'>('none')
  const openModal = (modalType: 'AddDocumentModal') => {
    setActiveModal(modalType)
  }

  const closeModal = () => {
    setActiveModal('none')
  }
  const {companyId, currentUser} = useAuth()
  const [searchParams] = useSearchParams()
  const meetingId = searchParams.get('meetingId')
  const [agendaData, setAgendaData] = useState<any>([])
  const [participantsData, setParticipantsData] = useState<any>([])
  const [meetingDetails, setMeetingDetails] = useState<any>()
  const [organizer, setOrganizer] = useState<any>()
  const [isMeetingDetailsLoading, setIsMeetingDetailsLoading] = useState(false)
  const [isMeetingAgendaLoading, setIsMeetingAgendaLoading] = useState(false)
  const [isMeetingParticipantLoading, setIsMeetingParticipantLoading] = useState(false)

  const [postMeetingData, setPostMeetingData] = useState<{
    boardResolution: any
    minutesOfMeeting: any
    transcript: any
    recordings: any
    otherDocuments: any
  }>()

  const getMeetingAgenda = async () => {
    if (!meetingId) return
    setIsMeetingAgendaLoading(true)
    try {
      const {
        data: {success, data},
      } = await getAgenda(meetingId, true)
      if (success) {
        setAgendaData(data.data)
      }
    } catch (err) {
      console.log(err)
    }finally{
      setIsMeetingAgendaLoading(false)
    }
  }
  const getMeetingParticipant = async () => {
    if (!meetingId) return
    setIsMeetingParticipantLoading(true)
    try {
      const {
        data: {success, data},
      } = await getParticipants(meetingId, true)
      if (success) {
        const responseData = data.data.map((item: any) => {
          let badge
          if (item.type === 'Host' || item.type === 'Co-Host') badge = 'primary'
          else if (item.type === 'Guest') badge = 'warning'
          else if (item.type === 'Observer') badge = 'success'
          else if (item.type === 'Organizer') badge = 'info'
          else if (item.type === 'Participant') badge = 'danger'
          else badge = 'warning'

          return {
            ...item,
            badge,
          }
        })
        setParticipantsData(responseData)
        setOrganizer(data.data.find((item: any) => item.type === 'Organizer'))
      }
    } catch (err) {
      console.log(err)
    }finally{
      setIsMeetingParticipantLoading(false)
    }
  }
  const getMeetingDetails = async () => {
    if (!meetingId) return
    setIsMeetingDetailsLoading(true)
    try {
      const {
        data: {success, data},
      } = await getMeetings(meetingId)

      if (success) {
        setMeetingDetails(data)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsMeetingDetailsLoading(false)
    }
  }
  const getSummaryData = async () => {
    if (!meetingId) return
    try {
      const {
        data: {success, data},
      } = await getMeetingSummary(meetingId)
      if (success) {
        const boardResolution = data.find(
          (item: any) => item.meetingInfoType === 'Board-Resolution'
        )
        const minutesOfMeeting = data.find(
          (item: any) => item.meetingInfoType === 'Minutes-Of-Meeting'
        )
        const transcript = data.find((item: any) => item.meetingInfoType === 'Transcript')
        const recordings = data.find((item: any) => item.meetingInfoType === 'Recording')
        const otherDocuments = data.find((item: any) => item.meetingInfoType === 'Other-Documents')
        setPostMeetingData({
          boardResolution,
          minutesOfMeeting,
          transcript,
          recordings,
          otherDocuments,
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  const apiCalling = async () => {
    if (meetingId) {
      await getMeetingDetails()
      await getMeetingAgenda()
      await getMeetingParticipant()
    }
  }
  useEffect(() => {
    getProfileInfo()
    apiCalling()
  }, [meetingId]) // eslint-disable-line react-hooks/exhaustive-deps
  const [imgName, setImgName] = useState()

  const getProfileInfo = async () => {
    try {
      if (companyId) {
        const {
          data: {success, data},
        } = await profileData(companyId)
        if (success) {
          setImgName(data.profileImage)
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    if (tab === 2) getSummaryData()
  }, [tab]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getSummaryData()
    getMeetingAgenda()
  }, [activeModal]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleDownload = async (name: string) => {
    try {
      const {
        data: {success, data},
      } = await downloadDocument(name, companyId!)
      if (success) {
        const link = document.createElement('a')
        link.href = data
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        link.remove()
      }
    } catch (error) {}
  }
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [cancelLoading, setCancelLoading] = useState(false)
  const [id, setId] = useState<any>()
  const [isActive, setIsActive] = useState(false)
  const [selectedFileName, setSelectedFileName] = useState('')
  const handleIsActive = (fileName: string) => {
    setSelectedFileName(fileName)
    setIsActive(!isActive)
  }

  const deleteFile = async () => {
    setCancelLoading(true)
    try {
      const {
        data: {success},
      } = await deleteDocument(id, companyId!)
      if (success) {
        toast.success(formatMessage({id: 'Document deleted successfully'}))
        getSummaryData()
        getMeetingAgenda()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteDocumentSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({id: 'Document not deleted'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteDocumentFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: formatMessage({id: 'Document not deleted'}),
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DeleteDocumentFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            document_id: id,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: error,
          },
        },
      })
    } finally {
      setCancelLoading(false)
      setShowCancelModal(false)
    }
  }
  return (
    <>
      <div
        className='p-0'
        style={{
          overflowX: 'scroll',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <div
          className='d-flex gap-3 col-md-8 col-12 mt-8 mt-md-0'
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {/* Rectangular tabs Start */}
          {options.map((opt, index) => (
            <div
              key={index}
              className={
                `col options-container p-4 align-content-center cursor-pointer ` +
                (tab === index + 1 ? ' selected-option' : '')
              }
              style={{width: '200px', flex: '0 0 auto'}}
              onClick={() => handleTabChange(index)}
            >
              <h1 className='m-0'>{formatMessage({id: opt.title})}</h1>
              <p className='mt-2' style={{whiteSpace: 'normal', color: '#656571'}}>
                {formatMessage({id: opt.subTitle})}
              </p>
            </div>
          ))}
        </div>
      </div>

      {tab === 1 && (
        <div className='bg-white rounded-2 p-4 mt-4'>
          {isMeetingAgendaLoading || isMeetingDetailsLoading || isMeetingParticipantLoading ? (
            <>
              <Skeleton
                height={40}
                count={1}
                width={'50%'}
                className='my-2 ms-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={40}
                count={1}
                width={'50%'}
                className='my-2 ms-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={40}
                count={1}
                width={'50%'}
                className='my-2 ms-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={40}
                count={1}
                width={'50%'}
                className='my-2 ms-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={500}
                count={1}
                width={'100%'}
                className='my-2 ms-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </>
          ) : (
            <>
              <div className='d-flex flex-column flex-md-row justify-content-between align-items-start'>
                <div>
                  <h2>
                    {meetingDetails?.meetingTitle} | {toTitleCase(meetingDetails?.category)}
                  </h2>
                  <p>
                    {getDateValue(meetingDetails?.meetingDate.toString())}{' '}
                    {` | ${getTimeZoneValue(
                      meetingDetails?.startTime.toString()
                    )} - ${getTimeZoneValue(meetingDetails?.endTime.toString())} `}
                    {`(${timeZone})`}
                  </p>
                </div>
                {currentUser?.userId === meetingDetails?.createdBy &&
                  getDaysDifference(meetingDetails?.meetingDate) >= 0 && (
                    <div className='d-flex flex-column flex-md-row gap-2 w-100 w-md-auto'>
                      <Link
                        to={`../view/add-board-meeting?tab=${sanitizeFileName(
                          meetingDetails?.category
                        ).toLowerCase()}&meetingId=${meetingDetails?.meetingId}`}
                      >
                        <button className='btn btn-primary w-100 w-md-auto mt-2 mt-md-0'>
                          {formatMessage({id: 'Edit Meeting'})}
                        </button>
                      </Link>
                    </div>
                  )}
              </div>

              <div className='d-flex flex-row'>
                {meetingDetails?.venue && meetingDetails?.type === 'Physical Meeting' && (
                  <div className='mt-5 w-50'>
                    <h5>{formatMessage({id: 'Meeting Venue'})}</h5>
                    <p className='text-primary cursor-pointer'>{meetingDetails?.venue}</p>
                  </div>
                )}
                <div className='mt-5'>
                  <h5>{formatMessage({id: 'Meeting URL'})}</h5>
                  <a href={meetingDetails?.link} target='_blank' rel='noreferrer'>
                    <p className='text-primary cursor-pointer'>{meetingDetails?.link}</p>
                  </a>
                  {/* <button className='btn btn-primary w-100 w-md-auto'>Start Meeting</button> */}
                </div>
              </div>

              <div className='mt-5'>
                <h5>{formatMessage({id: 'Organizer'})}</h5>
                <div className='d-flex'>
                  <DisplayImage
                    imgName={
                      organizer && organizer.profileImage.name
                        ? organizer.profileImage.name
                        : imgName && organizer.email === currentUser?.email
                        ? imgName
                        : 'dummy'
                    }
                    alt='profile'
                    fit='cover'
                    className='rounded-circle'
                    width={32}
                    height={32}
                  />
                  <div className='ms-4'>
                    <p className='m-0'>{toTitleCase(organizer?.name)}</p>
                    <p className='m-0'>
                      {organizer?.isGuest
                        ? formatMessage({id: 'Guest'})
                        : formatMessage({id: 'Shareholder'})}
                    </p>
                  </div>
                </div>
              </div>
              {meetingDetails?.description && (
                <div className='mt-4 w-100'>
                  <h5>{formatMessage({id: 'Description'})}</h5>
                  <p className='text-muted' style={{wordBreak: 'break-word'}}>
                    {meetingDetails?.description}
                  </p>
                </div>
              )}

              {meetingDetails?.notes && (
                <div className='mt-4 w-100'>
                  <h5>{formatMessage({id: 'Notes for participants'})}</h5>
                  <p className='text-muted' style={{wordBreak: 'break-word'}}>
                    {meetingDetails?.notes}
                  </p>
                </div>
              )}

              <Row>
                <Col md={6} sm={12}>
                  <div
                    className='border border-1 p-4 rounded-2 mt-4'
                    style={{height: '400px', overflow: 'hidden'}}
                  >
                    <div className='d-flex justify-content-between align-items-center'>
                      <h5 className='mt-2 mb-4'>{formatMessage({id: 'Agenda'})}</h5>
                    </div>
                    <div className='seperator bg-dark border'></div>

                    <div className='mt-2' style={{overflowY: 'auto', maxHeight: '330px'}}>
                      {agendaData.map((agenda: any) => (
                        <div
                          className='d-flex align-items-center justify-content-between pt-4'
                          key={agenda.agendaId}
                        >
                          <div className='d-flex align-items-center col-5'>
                            <div className='d-flex align-items-center gap-2'>
                              <div className=''>
                                <p
                                  className='mb-0 font-size-13'
                                  style={{
                                    whiteSpace: 'nowrap',
                                    width: '100px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {agenda.agendaTitle}
                                </p>
                                <div className='d-flex align-items-center gap-6'>
                                  {agenda.presenter && (
                                    <p
                                      className='mb-0 font-size-12 text-muted'
                                      style={{wordBreak: 'break-word'}}
                                    >
                                      {`Presenter: ${toTitleCase(agenda.presenter)}`}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <p className='mb-0 font-size-12 text-muted col-2'>{`${
                            agenda.assignedTime.split(' ')[0]
                          } mins`}</p>
                          <div className='d-flex flex-start col-5'>
                            {agenda.AgendaDocuments.length > 0
                              ? agenda?.AgendaDocuments.slice(
                                  0,
                                  agenda?.AgendaDocuments.length > 2
                                    ? 2
                                    : agenda?.AgendaDocuments.length
                                ).map((doc: any) => (
                                  <>
                                    <img
                                      key={doc.documentsId}
                                      src={getFileType(doc.file.name)}
                                      alt='Document icon'
                                      width={32}
                                      height={32}
                                    />
                                  </>
                                ))
                              : 'No files'}
                            {agenda.AgendaDocuments?.length > 2 && (
                              <span className='ms-2'>
                                {`& ${
                                  agenda.AgendaDocuments?.length - 2 === 1
                                    ? '1 more file'
                                    : `${agenda.AgendaDocuments?.length - 2} more files`
                                }`}
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                      {/* Add more participants here to test scrolling */}
                    </div>
                  </div>
                </Col>
                <Col md={6} sm={12}>
                  <div
                    className='border border-1 p-4 rounded-2 mt-4'
                    style={{height: '400px', overflow: 'hidden'}}
                  >
                    <div className='d-flex justify-content-between align-items-center'>
                      <h5 className='mt-2 mb-4'>
                        {formatMessage({id: 'Participants'})} ({participantsData?.length})
                      </h5>
                    </div>
                    <div className='seperator bg-dark border'></div>

                    <div className='mt-2' style={{overflowY: 'auto', maxHeight: '330px'}}>
                      {participantsData.map((participant: any) => (
                        <div
                          className='d-flex align-items-center justify-content-between pt-4'
                          key={participant.meetingParticipantId}
                        >
                          <div className='d-flex align-items-center col-8'>
                            <div className='d-flex align-items-center gap-2'>
                              <DisplayImage
                                imgName={
                                  participant.profileImage.name
                                    ? participant.profileImage.name
                                    : imgName && participant.email === currentUser?.email
                                    ? imgName
                                    : 'dummy'
                                }
                                alt='profile'
                                fit='cover'
                                className='rounded-circle'
                                width={32}
                                height={32}
                              />
                              <div className='' style={{wordBreak: 'break-word'}}>
                                <p className='mb-0 font-size-13'>{toTitleCase(participant.name)}</p>
                                <p className='mb-0 font-size-12 text-muted'>
                                  {participant.email}
                                  {participant.isGuest
                                    ? formatMessage({id: ' . Guest'})
                                    : formatMessage({id: ' . Shareholder'})}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`badge alert-${participant.badge} px-4 py-2 w-100px col-2`}
                          >
                            <span className='flex-root'>{participant.type}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      )}
      {tab === 2 && (
        <div className='bg-white rounded-2 p-4 mt-4'>
          {isMeetingAgendaLoading || isMeetingDetailsLoading || isMeetingParticipantLoading ? (
            <>
              <Skeleton
                height={40}
                count={1}
                width={'100%'}
                className='my-2 me-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={100}
                count={1}
                width={'100%'}
                className='my-2 me-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={100}
                count={1}
                width={'100%'}
                className='my-2 me-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={100}
                count={1}
                width={'100%'}
                className='my-2 me-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={100}
                count={1}
                width={'100%'}
                className='my-2 me-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={100}
                count={1}
                width={'100%'}
                className='my-2 me-3'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </>
          ) : (
            <>
              <div className='d-md-flex justify-content-between align-items-center mb-4'>
                <h3 className='m-0'>{formatMessage({id: 'Meeting Documents'})}</h3>
                {currentUser?.userId === meetingDetails.createdBy && meetingDetails.schedule && (
                  <button
                    className='btn btn-primary w-100 w-md-auto'
                    onClick={() => {
                      openModal('AddDocumentModal')
                    }}
                  >
                    {formatMessage({id: 'Add Documents'})}
                  </button>
                )}
              </div>
              <Accordion>
                {/* Recordings Section */}
                <Accordion.Item eventKey='0' className='mt-2 border border-1'>
                  <Accordion.Header>
                    {formatMessage({id: 'Recordings'})}{' '}
                    <span className='badge bg-primary ms-2'>
                      {postMeetingData?.recordings
                        ? postMeetingData?.recordings.SummaryDocuments.length
                        : 0}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {postMeetingData?.recordings && postMeetingData?.recordings.SummaryDocuments ? (
                      <>
                        <div className='d-flex flex-wrap'>
                          {postMeetingData?.recordings.SummaryDocuments.map((data: any) => {
                            return (
                              <Card className='mx-2 p-4 border border-grey cursor-pointer w-200px'>
                                <img
                                  src={getFileType(data.file.fileName)}
                                  alt='Document icon'
                                  width={44}
                                  height={44}
                                />
                                <Card.Text className='m-0 mt-4'>
                                  {shortenFilename(data.file.fileName)}
                                </Card.Text>
                                <div className='d-flex align-items-center gap-4'>
                                  {viewableFile(data.file.fileName.toLowerCase()) && (
                                    <button className='btn btn-secondry p-0 m-0'>
                                      <img
                                        src={viewIcon}
                                        alt='View'
                                        onClick={() => handleIsActive(data.file.name)}
                                      />
                                    </button>
                                  )}
                                  <button className='bg-transparent border border-0'>
                                    <img
                                      src={Downloadicon}
                                      alt='download icons'
                                      width={24}
                                      height={24}
                                      style={{filter: 'grayscale(100%)'}}
                                      onClick={() => handleDownload(data.file.name)}
                                    />
                                  </button>
                                  <button
                                    className='btn btn-secondry p-0 m-0'
                                    onClick={() => {
                                      setId(data.documentId)
                                      setShowCancelModal(true)
                                    }}
                                  >
                                    <img src={deleteIcon} alt='Delete' />
                                  </button>
                                </div>
                              </Card>
                            )
                          })}
                        </div>
                      </>
                    ) : (
                      <p>{formatMessage({id: 'No documents available.'})}</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey='1' className='mt-2 border border-1 '>
                  <Accordion.Header
                    className={`accordion-button p-0 ${collapseAcc ? 'hideIt' : ''}`}
                    onClick={() => {
                      setCollapseAcc(!collapseAcc)
                    }}
                  >
                    {formatMessage({id: 'Board Resolution'})}{' '}
                    <span className='badge bg-primary ms-2'>
                      {postMeetingData?.boardResolution
                        ? postMeetingData?.boardResolution.SummaryDocuments.length
                        : 0}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {postMeetingData?.boardResolution &&
                    postMeetingData?.boardResolution?.resolutionNote !== '<p><br></p>' ? (
                      <>
                        <p className='fw-semibold ms-2'>{formatMessage({id: 'Notes'})}</p>
                        <p className='w-md-50 w-100 ms-2'>
                          {postMeetingData?.boardResolution &&
                            postMeetingData?.boardResolution?.resolutionNote && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: postMeetingData.boardResolution.resolutionNote,
                                }}
                              />
                            )}
                        </p>
                        <div className='d-flex flex-wrap'>
                          {postMeetingData?.boardResolution &&
                            postMeetingData.boardResolution.SummaryDocuments.map((data: any) => {
                              return (
                                <Card className='m-2 p-2 border border-secondary cursor-pointer'>
                                  <img
                                    src={getFileType(data.file.fileName)}
                                    alt='Document icon'
                                    width={44}
                                    height={44}
                                  />
                                  <Card.Text className='px-3 m-0'>
                                    {shortenFilename(data.file.fileName)}
                                  </Card.Text>
                                  <div className='d-flex align-items-center gap-4'>
                                    {viewableFile(data.file.fileName.toLowerCase()) && (
                                      <button className='btn btn-secondry p-0 m-0'>
                                        <img
                                          src={viewIcon}
                                          alt='View'
                                          onClick={() => handleIsActive(data.file.name)}
                                        />
                                      </button>
                                    )}
                                    <button className='bg-transparent border border-0'>
                                      <img
                                        src={Downloadicon}
                                        alt='download icons'
                                        width={24}
                                        height={24}
                                        style={{filter: 'grayscale(100%)'}}
                                        onClick={() => handleDownload(data.file.name)}
                                      />
                                    </button>
                                    <button
                                      className='btn btn-secondry p-0 m-0'
                                      onClick={() => {
                                        setId(data.documentId)
                                        setShowCancelModal(true)
                                      }}
                                    >
                                      <img src={deleteIcon} alt='Delete' />
                                    </button>
                                  </div>
                                </Card>
                              )
                            })}
                        </div>
                      </>
                    ) : (
                      <p>{formatMessage({id: 'No documents available.'})}</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>

                {/* Minutes of Meeting Section */}
                <Accordion.Item eventKey='2' className='mt-2 border border-1'>
                  <Accordion.Header>
                    {formatMessage({id: 'Minutes of Meeting'})}{' '}
                    <span className='badge bg-primary ms-2'>
                      {postMeetingData?.minutesOfMeeting
                        ? postMeetingData?.minutesOfMeeting.SummaryDocuments.length
                        : 0}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {postMeetingData?.minutesOfMeeting &&
                    postMeetingData?.minutesOfMeeting?.minutesOfMeetingNotes !== '<p><br></p>' ? (
                      <>
                        <p className='fw-semibold ms-2'>{formatMessage({id: 'Notes'})}</p>
                        <p className='w-md-50 w-100 ms-2'>
                          {postMeetingData?.minutesOfMeeting?.minutesOfMeetingNotes && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: postMeetingData?.minutesOfMeeting?.minutesOfMeetingNotes,
                              }}
                            />
                          )}
                        </p>
                        <div className='d-flex flex-wrap'>
                          {postMeetingData?.minutesOfMeeting &&
                            postMeetingData.minutesOfMeeting.SummaryDocuments.map((data: any) => {
                              return (
                                <Card className='m-2 p-2 border border-secondary cursor-pointer'>
                                  <img
                                    src={getFileType(data.file.fileName)}
                                    alt='Document icon'
                                    width={44}
                                    height={44}
                                  />
                                  <Card.Text className='px-3 m-0'>
                                    {shortenFilename(data.file.fileName)}
                                  </Card.Text>
                                  <div className='d-flex align-items-center gap-4'>
                                    {viewableFile(data.file.fileName.toLowerCase()) && (
                                      <button className='btn btn-secondry p-0 m-0'>
                                        <img
                                          src={viewIcon}
                                          alt='View'
                                          onClick={() => handleIsActive(data.file.name)}
                                        />
                                      </button>
                                    )}
                                    <button className='bg-transparent border border-0'>
                                      <img
                                        src={Downloadicon}
                                        alt='download icons'
                                        width={24}
                                        height={24}
                                        style={{filter: 'grayscale(100%)'}}
                                        onClick={() => handleDownload(data.file.name)}
                                      />
                                    </button>
                                    <button
                                      className='btn btn-secondry p-0 m-0'
                                      onClick={() => {
                                        setId(data.documentId)
                                        setShowCancelModal(true)
                                      }}
                                    >
                                      <img src={deleteIcon} alt='Delete' />
                                    </button>
                                  </div>
                                </Card>
                              )
                            })}
                        </div>
                      </>
                    ) : (
                      <p>{formatMessage({id: 'No documents available.'})}</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>

                {/* Transcript Section */}
                <Accordion.Item eventKey='3' className='mt-2 border border-1'>
                  <Accordion.Header>
                    {formatMessage({id: 'Transcript'})}{' '}
                    <span className='badge bg-primary ms-2'>
                      {postMeetingData?.transcript
                        ? postMeetingData?.transcript.SummaryDocuments.length
                        : 0}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {postMeetingData?.transcript &&
                    postMeetingData?.transcript?.transcriptNotes !== '<p><br></p>' ? (
                      <>
                        <p className='fw-semibold ms-2'>{formatMessage({id: 'Notes'})}</p>
                        <p className='w-md-50 w-100 ms-2'>
                          {
                            <div
                              dangerouslySetInnerHTML={{
                                __html: postMeetingData?.transcript.aiTranscript,
                              }}
                            />
                          }
                        </p>
                        <div className='d-flex flex-wrap'>
                          {postMeetingData.transcript.SummaryDocuments.map((data: any) => {
                            return (
                              <Card className='m-2 p-2 border border-secondary cursor-pointer'>
                                <img
                                  src={getFileType(data.file.fileName)}
                                  alt='Document icon'
                                  width={44}
                                  height={44}
                                />
                                <Card.Text className='px-3 m-0'>
                                  {shortenFilename(data.file.fileName)}
                                </Card.Text>
                                <div className='d-flex align-items-center gap-4'>
                                  {viewableFile(data.file.fileName.toLowerCase()) && (
                                    <button className='btn btn-secondry p-0 m-0'>
                                      <img
                                        src={viewIcon}
                                        alt='View'
                                        onClick={() => handleIsActive(data.file.name)}
                                      />
                                    </button>
                                  )}
                                  <button className='bg-transparent border border-0'>
                                    <img
                                      src={Downloadicon}
                                      alt='download icons'
                                      width={24}
                                      height={24}
                                      style={{filter: 'grayscale(100%)'}}
                                      onClick={() => handleDownload(data.file.name)}
                                    />
                                  </button>
                                  <button
                                    className='btn btn-secondry p-0 m-0'
                                    onClick={() => {
                                      setId(data.documentId)
                                      setShowCancelModal(true)
                                    }}
                                  >
                                    <img src={deleteIcon} alt='Delete' />
                                  </button>
                                </div>
                              </Card>
                            )
                          })}
                        </div>
                      </>
                    ) : (
                      <p>{formatMessage({id: 'No documents available.'})}</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>

                {/* Other Documents Section */}
                <Accordion.Item eventKey='4' className='mt-2 border border-1'>
                  <Accordion.Header>
                    {formatMessage({id: 'Other Documents'})}
                    <span className='badge bg-primary ms-2'>
                      {(postMeetingData?.otherDocuments
                        ? postMeetingData.otherDocuments.SummaryDocuments.length
                        : 0) +
                        (agendaData
                          ? agendaData.reduce(
                              (total: number, agenda: any) => total + agenda.AgendaDocuments.length,
                              0
                            )
                          : 0)}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {postMeetingData?.otherDocuments?.SummaryDocuments ||
                    (agendaData &&
                      agendaData.some((agenda: any) => agenda.AgendaDocuments?.length)) ? (
                      <>
                        <div className='d-flex flex-wrap'>
                          {postMeetingData?.otherDocuments?.SummaryDocuments?.map(
                            (data: any, index: number) => (
                              <Card
                                key={index}
                                className='m-2 p-2 border border-secondary cursor-pointer'
                              >
                                <img
                                  src={getFileType(data.file.fileName)}
                                  alt='Document icon'
                                  width={44}
                                  height={44}
                                />
                                <Card.Text className='px-3 m-0'>
                                  {shortenFilename(data.file.fileName)}
                                </Card.Text>
                                <div className='d-flex align-items-center gap-4'>
                                  {viewableFile(data.file.fileName.toLowerCase()) && (
                                    <button className='btn btn-secondry p-0 m-0'>
                                      <img
                                        src={viewIcon}
                                        alt='View'
                                        onClick={() => handleIsActive(data.file.name)}
                                      />
                                    </button>
                                  )}
                                  <button className='bg-transparent border border-0'>
                                    <img
                                      src={Downloadicon}
                                      alt='download icons'
                                      width={24}
                                      height={24}
                                      style={{filter: 'grayscale(100%)'}}
                                      onClick={() => handleDownload(data.file.name)}
                                    />
                                  </button>
                                  <button
                                    className='btn btn-secondry p-0 m-0'
                                    onClick={() => {
                                      setId(data.documentId)
                                      setShowCancelModal(true)
                                    }}
                                  >
                                    <img src={deleteIcon} alt='Delete' />
                                  </button>
                                </div>
                              </Card>
                            )
                          )}
                          {agendaData?.map((data: any, index: number) =>
                            data.AgendaDocuments?.map((item: any, subIndex: number) => (
                              <Card
                                key={subIndex}
                                className='m-2 p-2 border border-secondary cursor-pointer'
                              >
                                <img
                                  src={getFileType(item.file.fileName)}
                                  alt='Document icon'
                                  width={44}
                                  height={44}
                                />
                                <Card.Text className='px-3 m-0'>
                                  {shortenFilename(item.file.fileName)}
                                </Card.Text>
                                <div className='d-flex align-items-center gap-4'>
                                  {viewableFile(data.file.fileName.toLowerCase()) && (
                                    <button className='btn btn-secondry p-0 m-0'>
                                      <img
                                        src={viewIcon}
                                        alt='View'
                                        onClick={() => handleIsActive(data.file.name)}
                                      />
                                    </button>
                                  )}
                                  <button className='bg-transparent border border-0'>
                                    <img
                                      src={Downloadicon}
                                      alt='download icons'
                                      width={24}
                                      height={24}
                                      style={{filter: 'grayscale(100%)'}}
                                      onClick={() => handleDownload(data.file.name)}
                                    />
                                  </button>
                                  <button
                                    className='btn btn-secondry p-0 m-0'
                                    onClick={() => {
                                      setId(data.documentId)
                                      setShowCancelModal(true)
                                    }}
                                  >
                                    <img src={deleteIcon} alt='Delete' />
                                  </button>
                                </div>
                              </Card>
                            ))
                          )}
                        </div>
                      </>
                    ) : (
                      <p>{formatMessage({id: 'No documents available.'})}</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </>
          )}
        </div>
      )}
      <ViewDocModal
        isActive={isActive}
        setIsActive={setIsActive}
        handleIsActive={handleIsActive}
        fileName={selectedFileName}
      />
      <DeleteFileConfirmationModal
        setDeleteShowModal={setShowCancelModal}
        showDeleteModal={showCancelModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={cancelLoading}
      />
      {activeModal === 'AddDocumentModal' && (
        <AddDocumentModal isActive={true} setIsActive={closeModal} meeting={meetingDetails} />
      )}
    </>
  )
}

export default AfterMeeting
